/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_After_TitleInputs */



/**
* | output |
* | --- |
* | "After the conversation" |
*
* @param {Notifications_After_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const notifications_after_title = /** @type {((inputs?: Notifications_After_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_After_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Na het gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Après la conversation")
	return /** @type {LocalizedString} */ ("After the conversation")
});